module.exports = __webpack_public_path__ + "static/media/kartpasshorizontal.26049831.png";